import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c585fd0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c585fd0')) {
      api.createRecord('5c585fd0', component.options)
    } else {
      api.reload('5c585fd0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c585fd0", function () {
      api.rerender('5c585fd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/ProfileTemplates/index.vue"
export default component.exports